/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Handle_domain_read_handle_read_nameserver_read } from './Handle_domain_read_handle_read_nameserver_read';
import type { Nameserver_domain_read_handle_read_nameserver_read } from './Nameserver_domain_read_handle_read_nameserver_read';

export type Domain_domain_read_handle_read_nameserver_read = {
    readonly id?: string;
    readonly name?: string;
    readonly adminHandle?: Handle_domain_read_handle_read_nameserver_read | null;
    readonly techHandle?: Handle_domain_read_handle_read_nameserver_read | null;
    readonly ownerHandle?: Handle_domain_read_handle_read_nameserver_read | null;
    readonly zoneHandle?: Handle_domain_read_handle_read_nameserver_read | null;
    readonly isDomainTransferLocked?: boolean;
    readonly authCode?: string | null;
    readonly authCodeExpiryDate?: string | null;
    readonly isAutoRenewEnabled?: boolean;
    readonly registrationDate?: string;
    readonly status?: Domain_domain_read_handle_read_nameserver_read.status;
    readonly nameservers?: Array<Nameserver_domain_read_handle_read_nameserver_read>;
    readonly transitType?: Domain_domain_read_handle_read_nameserver_read.transitType | null;
    readonly dnsZoneId?: string | null;
};

export namespace Domain_domain_read_handle_read_nameserver_read {

    export enum status {
        CREATED = 'created',
        PENDING = 'pending',
        ONLINE = 'online',
        DELETED = 'deleted',
        PENDING_DELETE = 'pendingDelete',
        FAILED_NAMESERVER = 'failedNameserver',
        FAILED_REGISTRATION = 'failedRegistration',
        FAILED_TRANSFER = 'failedTransfer',
        UNKNOWN = 'unknown',
        TRANSFERED_OUT = 'transferedOut',
        TRANSIT = 'transit',
        PENDING_TRANSIT = 'pendingTransit',
        ZONE_CREATED = 'zoneCreated',
    }

    export enum transitType {
        CONNECTED = 'connected',
        DISCONNECTED = 'disconnected',
    }


}

